import React, { Component, Fragment } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/styles"
import {
  Typography,
  Icon,
  Tooltip,
  Menu,
  MenuItem,
  IconButton,
  Divider,
  Hidden,
} from "@material-ui/core"
import SortIcon from "@material-ui/icons/Sort"
import classNames from "classnames"

export const sortOptions = [
  {
    name: "Date",
    shootKey: "start_date",
    func: (shoots, shootKey, dir) =>
      shoots.sort(
        (a, b) =>
          dir
            ? new Date(a[shootKey]) - new Date(b[shootKey])
            : new Date(b[shootKey]) - new Date(a[shootKey])
      ),
    dir: true,
    id: 1,
  },
  {
    name: "Name",
    shootKey: "name",
    func: (shoots, shootKey, dir) =>
      shoots.sort(
        (a, b) =>
          dir
            ? a[shootKey].localeCompare(b[shootKey])
            : b[shootKey].localeCompare(a[shootKey])
      ),
    dir: true,
    id: 2,
  },
]

class SortBy extends Component {
  state = {
    sortMenuAnchorEl: null,
    searchMenuAnchorEl: null,
  }

  handleOpenMenu = (e, name) => {
    this.setState({ [`${name}MenuAnchorEl`]: e.currentTarget })
  }
  handleCloseMenu = name => {
    this.setState({ [`${name}MenuAnchorEl`]: null })
  }
  clearFilters = name => {
    this.props.setSortFilter(null)
    this.handleCloseMenu(name)
  }
  // componentWillUnmount() {
  //   this.props.setSortFilter(null)
  // }
  componentWillMount() {
    this.props.setSortFilter(null)
  }
  render() {
    const { state, props } = this
    const { sortMenuAnchorEl } = state
    const { classes, sort, disabled } = props
    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          {sort && (
            <Tooltip title="remove sort" placement="top">
              <Icon
                style={{ cursor: "pointer", color: "grey" }}
                onClick={() => props.setSortFilter(null)}
              >
                close
              </Icon>
            </Tooltip>
          )}
          <Typography className={classes.sortBy}>Sort By:</Typography>
          {sortOptions.map((sortOption, i) => {
            return (
              <div
                key={i}
                className={classes.sortOptionWrapper}
                onClick={() => {
                  // props.onClick

                  if (!disabled) {
                    sort && sort.name === sortOption.name
                      ? props.setSortFilter(sortOption, sort.dir)
                      : props.setSortFilter(sortOption)
                    // this.props.onClickItem()
                  }
                }}
              >
                <Typography
                  className={classNames(props.classes.sortOption, {
                    [classes.sortOptionDisabled]: disabled,
                  })}
                >
                  {sortOption.name}
                </Typography>
                {sort &&
                  sort.name === sortOption.name && (
                    <Icon>
                      {sort.dir ? "arrow_drop_down" : "arrow_drop_up"}
                    </Icon>
                  )}
              </div>
            )
          })}
        </Hidden>
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <IconButton
            className={this.props.classes.sortButton}
            onClick={e => this.handleOpenMenu(e, "sort")}
            disabled={disabled}
          >
            <SortIcon />
          </IconButton>
          <Menu
            anchorEl={sortMenuAnchorEl}
            open={Boolean(sortMenuAnchorEl)}
            onClose={() => this.handleCloseMenu("sort")}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem>
              <Typography style={{ fontWeight: "bold" }}>Sort By:</Typography>
            </MenuItem>
            <Divider />
            {sortOptions.map((sortOption, i) => {
              return (
                <MenuItem
                  key={i}
                  className={classes.sortOptionWrapper}
                  onClick={() => {
                    sort && sort.name === sortOption.name
                      ? props.setSortFilter(sortOption, sort.dir)
                      : props.setSortFilter(sortOption)
                  }}
                >
                  {sortOption.name}
                  {sort &&
                    sort.name === sortOption.name && (
                      <Icon>
                        {sort.dir ? "arrow_drop_down" : "arrow_drop_up"}
                      </Icon>
                    )}
                </MenuItem>
              )
            })}
            {sort && (
              <MenuItem onClick={() => this.clearFilters("sort")}>
                <Tooltip title="remove sort" placement="top">
                  <Icon
                    color="primary"
                    style={{ fontSize: 20, marginRight: 8 }}
                  >
                    close
                  </Icon>
                </Tooltip>
                <Typography color="primary">Clear Filters</Typography>
              </MenuItem>
            )}
          </Menu>
        </Hidden>
      </Fragment>
    )
  }
}

export default withStyles(styles)(SortBy)
